import { gql } from '@apollo/client';
import { CHARGE_PRICE_FRAGMENT } from './chargePriceFragment';

export const QUOTE_FEE_FRAGMENT = gql`
  fragment QuoteFeeFields on QuoteFeeResponse {
    id
    type
    amount
    parentId
    isTaxable
    sortOrder
    amountType
    description
    equipmentId
    isFromCommonRules
    customerVisibility
    cap {
      min
      max
    }
    price {
      ...ChargePriceFields
    }
  }
  ${CHARGE_PRICE_FRAGMENT}
`;
